import { Api } from './api';
import { SignProviderApp } from '../../config/Auth/SignProvider/SignProviderApp';

Api.provider = SignProviderApp;
export default Api.ApiService;
